// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "head-268CC";
var _3 = "header-1TE6k";
var _4 = "description-ikM5s";
export { _1 as "__esModule", _2 as "head", _3 as "header", _4 as "description" }
export default { "__esModule": _1, "head": _2, "header": _3, "description": _4 }
